import React, { Component, Fragment } from 'react';
import { object, oneOf, shape, string, func, bool } from 'prop-types';
import axios from 'axios';
import classNames from 'classnames/bind';
import { Tabs, TabPanel } from 'react-context-tabs';

import ResultsList from 'components/ResultsList';
import SearchResultsTab from 'components/SearchResultsTab';
import NoResults from 'components/NoResults';
import Loader from 'components/Loader';
import { withWindowSizeContext } from 'containers/withWindowSizeContext';
import { withSearchContext } from 'containers/withSearchContext';
import { withCountryContext } from 'containers/withCountryContext';
import { getArtclesInfo } from 'utils/getArtclesInfo';
import { gtmPushEvent } from 'utils/gtmPushEvent';
import { langCode, currentLanguage, initialSearchTab } from 'utils/currentLanguage';
import browserHistory from 'utils/browserHistory';
import {
  PROVIDER_ID,
  VALEO_BRANDS,
  OTHER_BRANDS,
  tecDocUrl,
  basicAuth,
  getIsValeoBrand,
} from 'utils/constantsHelper';
import { changeRouteHash, getCurrentTab } from 'utils/tabsHelper';
import { clearSearchHistory } from 'utils/historyPushSearch';
import { baiduTriggerEvent } from 'utils/baiduTriggerEvent';
import { setBrowserHistory } from 'utils/historyPushSearch';

import SearchTabs from '../SearchTabs';
import SearchAccordion from '../SearchAccordion';

import styles from './SearchTabsContainer.module.scss';
const cx = classNames.bind(styles);

class SearchTabsContainer extends Component {
  constructor() {
    super();

    this._isMounted = false;
    this.state = {
      data: [],
      dataByVin: [],
      dataByRef: [],
      loading: false,
      noResults: false,
      noResultsByVin: false,
      noResultsByRef: false,
      selectedTabId: initialSearchTab,
    };
  }

  setSearchData = (data) => {
    this.setState({
      data: data,
    });
  };

  setRefData = (data) => {
    if (this._isMounted) {
      this.setState({
        dataByRef: data,
      });
    }
  };

  setRefNoResults = (noResults) => {
    if (this._isMounted) {
      this.setState({
        noResultsByRef: noResults,
      });
    }
  };

  buildArticlesArray(response) {
    let articlesArray = [];
    let valeoArray = [];
    const { array: data = [] } = response.data.data || {};

    const dataSorted = [...VALEO_BRANDS, ...OTHER_BRANDS].reduce(
      (accumulator, id) => [
        ...accumulator,
        ...data.filter(({ brandNo }) => brandNo === id),
      ],
      []
    );

    if (dataSorted) {
      dataSorted.forEach(({ articleId, articleLinkId, brandNo }) => {
        const isValeoBrand = getIsValeoBrand(VALEO_BRANDS, brandNo);
        const current = {
          articleId,
          articleLinkId,
        };

        if (isValeoBrand) {
          valeoArray.push(current);
        } else {
          articlesArray.push(current);
        }
      });
    }

    return valeoArray.concat(articlesArray).slice(0, 24);
  }

  // @todo: move this function to separate HOC.
  // @todo: optimize requests with https://github.com/axios/axios/issues/371
  getArticlesIds = () => {
    const { currentCountry } = this.props.contextCountry;
    const {
      vehicleType,
      carId,
      partId,
      modelId,
      manuId,
      vinNumber,
      partName,
      manuName,
      modelName,
      carTypeName,
      kbaNumber,
    } = this.props.contextSearch;

    this.setState({
      data: [],
      loading: true,
    });

    // gtm event search values
    const searchValues = Object.fromEntries(
      [
        ['carBrandManufacturer', manuName],
        ['carBrandModel', modelName],
        ['carBrandVehicle', carTypeName],
        ['product', partName],
        ['kba', kbaNumber],
        ['vin', vinNumber],
      ].filter(([_key, value]) => value !== ''));

    const calculatedVehicleType = carId && carId > 1000000 ? 'O' : 'P';

    axios
      .post(
        tecDocUrl,
        {
          getArticleIdsWithState: {
            lang: langCode,
            articleCountry: currentCountry,
            linkingTargetId: carId,
            linkingTargetType: calculatedVehicleType,
            favouredList: 0,
            brandNo: {
              array: [...VALEO_BRANDS, ...OTHER_BRANDS],
            },
            genericArticleId: {
              array: [partId],
            },
            provider: PROVIDER_ID,
          },
        },
        { headers: basicAuth }
      )
      .then((response) => {
        let noResults = true;
        let numberOfResults = 0;
        if (
          response.status === 200 &&
          response.data.status === 200 &&
          this._isMounted
        ) {
          const articles = this.buildArticlesArray(response);
          const calculatedVehicleType = carId && carId > 1000000 ? 'O' : 'P';
          const articlesHeaders = {
            articleCountry: currentCountry,
            linkingTargetId: carId,
            linkingTargetType: calculatedVehicleType,
            manuId: manuId,
            modId: modelId,
            articleIdPairs: {
              array: articles,
            },
          };

          if (articles.length) {
            this.setState({
              loading: true,
            });
            getArtclesInfo(articlesHeaders, this.articlesSucces);
            noResults = false;
            numberOfResults = articles.length;
          } else {
            this.setState({
              data: [],
              noResults: true,
            });

            // Trigger gtm no search result
            gtmPushEvent({
              event: 'techassistSearchNoResults',
              ...searchValues
            })
          }
        } else {
          // Here could be and error message of response status.
          this.setState({
            data: [],
            noResults: true,
          });

          // Trigger gtm no search result
          gtmPushEvent({
            event: 'techassistSearchNoResults',
            ...searchValues
          })
        }
        // Trigger Baidu
        baiduTriggerEvent({
          event: 'searchTA',
          payload: {
            ...this.props.contextSearch,
            noResults,
            numberOfResults,
            currentCountry,
          },
        });
      })
      .catch(() => {
        if (this._isMounted) {
          this.setState({
            noResults: true,
          });
          // Trigger Baidu
          baiduTriggerEvent({
            event: 'searchTA',
            payload: {
              ...this.props.contextSearch,
              noResults: true,
              numberOfResults: 0,
              currentCountry,
            },
          });
        }
      })
      .then(() => {
        if (this._isMounted) {
          this.setState({
            loading: false,
          });
        }
      });
  };

  articlesSucces = (response) => {
    if (this._isMounted) {
      this.setState({
        noResults: false,
        loading: false,
        data: response.data.array,
      });
    }
  };

  // @todo: Refactor to
  resetSearchResults = () => {
    const context = this.props.contextSearch;
    context.setIsSelectedCar(false);
    context.setIsSelectedModel(false);
    context.setIsSelectedManu(false);
    context.setIsSelectedVinVehicle(false);
    context.setIsSelectedCarPlate(false);
    context.setIsSelectedKba(false);
    context.setIsErrorCar(false);
    context.setIsErrorManu(false);
    context.setIsErrorPart(false);
    context.setIsErrorModel(false);
    context.setIsErrorVinVehicle(false);
    context.setVinNumber('');
    context.setSearchCarQuery(null);
    context.setCarTypeName('');

    context.setPartName('');
    context.setPartId(null);
    context.setCarTypeName('');
    context.setCarName('');
    context.setCarId(null);
    context.setManuName('');
    context.setManuId(null);
    context.setModelName('');
    context.setModelId(null);
    context.setReference('');
    context.setCarPlate('');
    context.setKbaNumber('');

    context.setVinVehicle('');
    context.setReference(null);
    context.setIsEditedManuField(false);
    context.setIsEditedModelField(false);
    context.setIsEditedCarField(false);
    context.setIsEditedVinVehicleField(false);
    context.setIsEditedPartField(false);
    this.setState({
      data: [],
      noResults: false,
    });
  };

  createTabChangeAction = (nextTabId) => {
    const nextId = typeof nextTabId === 'string' ? nextTabId : nextTabId[0];
    const { vehicleType, setVehicleType } = this.props.contextSearch;
    const { search, hash } = browserHistory.location;

    if (nextId !== 'car' && vehicleType === 'O') {
      setBrowserHistory({ vehicleType: 'P' }, search, hash);
      setVehicleType('P');
    }

    if (nextId !== 'reference') {
      this.resetSearchResults();
      clearSearchHistory(browserHistory.location.search);
    }

    changeRouteHash(nextId);
    this.setState({ selectedTabId: nextId });
  };

  componentDidUpdate(nextProps, nextState) {
    const currentTab = getCurrentTab();

    if (
      currentTab.length &&
      currentTab !== this.state.selectedTabId &&
      nextState.selectedTabId === this.state.selectedTabId
    ) {
      this.setState({
        selectedTabId: currentTab || initialSearchTab,
      });
    }
  }

  componentDidMount() {
    this.setState({
      selectedTabId: getCurrentTab() || initialSearchTab,
    });
    this._isMounted = true;

    if (this.props.pageType === 'home') {
      this.resetSearchResults();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setState({
      data: null,
      dataByRef: null,
      noResults: null,
      noResultsByRef: null,
    });
  }

  render() {
    const {
      setRefData,
      setRefNoResults,
      getArticlesIds,
      resetSearchResults,
      createTabChangeAction,
      props: {
        pageType,
        contextSearch: { reference },
        contextWindowSize: { isMobile },
      },
      state: {
        data,
        dataByRef,
        noResults,
        noResultsByRef,
        loading,
        selectedTabId,
      },
    } = this;
    const isGermanSite = currentLanguage === 'de';

    return (
      <Fragment>
        {isMobile ? (
          <SearchAccordion
            pageType={pageType}
            selectedTabId={selectedTabId}
            setRefData={setRefData}
            setRefNoResults={setRefNoResults}
            getArticlesIds={getArticlesIds}
            resetSearchResults={resetSearchResults}
            createTabChangeAction={createTabChangeAction}
            reference={reference}
            data={data}
            dataByRef={dataByRef}
            noResults={noResults}
            noResultsByRef={noResultsByRef}
            loading={loading}
          />
        ) : (
          <SearchTabs
            pageType={pageType}
            selectedTabId={selectedTabId}
            setRefData={setRefData}
            setRefNoResults={setRefNoResults}
            getArticlesIds={getArticlesIds}
            resetSearchResults={resetSearchResults}
            createTabChangeAction={createTabChangeAction}
            reference={reference}
            data={data}
            dataByRef={dataByRef}
            noResults={noResults}
            noResultsByRef={noResultsByRef}
            loading={loading}
          />
        )}

        {pageType === 'search' && (
          <Tabs
            className={cx(pageType, 'search-tabs')}
            selectedTabId={selectedTabId}
            onTabChange={createTabChangeAction}
          >
            <TabPanel tabId="car">
              <SearchResultsTab
                loading={loading}
                data={data}
                noResults={noResults}
              />
            </TabPanel>
            {isGermanSite ? (
              <TabPanel tabId="kba">
                <SearchResultsTab
                  loading={loading}
                  data={data}
                  noResults={noResults}
                />
              </TabPanel>
            ) : (
              <TabPanel tabId="vin">
                <SearchResultsTab
                  loading={loading}
                  data={data}
                  noResults={noResults}
                />
              </TabPanel>
            )}
            <TabPanel tabId="reference">
              <div className={cx('results-wrapper', 'white-bg')}>
                {loading ? (
                  <Loader />
                ) : (
                  <div className={cx('results-container')}>
                    {!noResultsByRef ? (
                      <ResultsList data={dataByRef} />
                    ) : (
                      <NoResults searchWord={reference} />
                    )}
                  </div>
                )}
              </div>
            </TabPanel>
          </Tabs>
        )}
      </Fragment>
    );
  }
}

SearchTabsContainer.propTypes = {
  pageType: oneOf(['home', 'search']),
  contextWindowSize: shape({
    isMobile: bool,
  }).isRequired,
  contextSearch: object.isRequired,
  contextCountry: shape({
    currentCountry: string.isRequired,
    setCurrentCountry: func.isRequired,
  }).isRequired,
};

SearchTabsContainer.defaultProps = {
  pageType: 'home',
};

export default withCountryContext(
  withSearchContext(withWindowSizeContext(SearchTabsContainer))
);



// WEBPACK FOOTER //
// ./src/components/SearchTabsContainer/SearchTabsContainer.js